import iframeResizerUtils from './iframeResizerUtils';

export function scrollToTop() {
  iframeResizerUtils.scrollToTop(); // For iframe resizer

  if (window.scroll) {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  } else {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
}

export function scrollToElement(element: Element) {
  if (iframeResizerUtils.scrollToElement(element)) return; // For iframe resizer

  element.scrollIntoView?.({ block: 'start', inline: 'nearest', behavior: 'smooth' });
}
